import { css } from 'aphrodite';
import React from 'react';
import { CampaignType } from '../../../../models/AdminModels';
import { CalendarCardType } from '../../../components/campaigns/CampaignCalendar/presentation';
import { bs } from '../../../styles/styles';
import { styleSheet } from './styles';

export const ContentCalendarLegend = ({
	campaignType,
	onSetCampaignType,
	showText,
}: {
	campaignType: string[];
	onSetCampaignType: React.Dispatch<React.SetStateAction<string[]>>;
	showText: boolean;
}) => {
	React.useEffect(() => {
		if (campaignType.length === 0) {
			onSetCampaignType([CampaignType.Email, CampaignType.Social, CampaignType.Blog]);
		}
	}, [campaignType, onSetCampaignType]);

	const getCardKeyLabel = (key: string): React.ReactNode => {
		return key === CalendarCardType.Email ? (
			'Emails'
		) : key === CalendarCardType.Social ? (
			<>
				Social <span className={css(styleSheet.showSpan)}>Media</span>
			</>
		) : key === CalendarCardType.Blog ? (
			'Blogs'
		) : null;
	};

	const calendarCardType = ({ type }: { type: string }) => {
		return (
			<div>
				<span
					className={css(
						styleSheet.calendarCardTypeColor,
						type === CalendarCardType.Email ? styleSheet.calendarCardTypeColorEmail : undefined,
						type === CalendarCardType.Social ? styleSheet.calendarCardTypeColorSocial : undefined,
						type === CalendarCardType.Blog ? styleSheet.calendarCardTypeColorBlog : undefined
					)}
				/>
				<span className={css(!showText ? styleSheet.showLabel : undefined)}>{getCardKeyLabel(type)}</span>
			</div>
		);
	};

	/**
	 * @TODO add back in email multi campaign branch
	 */
	// const handleTypeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
	// 	const { id, checked } = e.target;
	// 	const type = id.replace('type-', '');
	// 	if (checked) {
	// 		onSetCampaignType([...campaignType, type]);
	// 		return;
	// 	}
	// 	onSetCampaignType(campaignType.filter(x => x !== type));
	// };

	return (
		<ul className={css(bs.flex, bs.horizontalStack)}>
			{Object.keys(CalendarCardType).map((x, i) => {
				return (
					<li className={css(bs.block, i === 0 ? styleSheet.listItem : undefined)} key={x}>
						{/** @TODO add back in email multi campaign branch */}
						{/* <Checkbox id={`type-${x}`} onChange={handleTypeChange} checked={campaignType.includes(x)}> */}
						{calendarCardType({ type: x })}
						{/* </Checkbox> */}
					</li>
				);
			})}
		</ul>
	);
};
